





































import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Examples extends Vue {
    private imageLinks: string[] = [
        'https://pbs.twimg.com/media/FDiAJcPVEAE97Zg?format=jpg&name=900x900',
        'https://pbs.twimg.com/media/EiiqIRJVgAAvynE?format=jpg&name=medium',
        'https://pbs.twimg.com/media/EOELBtfUcAAz0-g?format=jpg&name=900x900',
        'https://pbs.twimg.com/media/E41vrBLVEAE1Grj?format=jpg&name=large',
        'https://pbs.twimg.com/media/EzNp8sAVoAU0x5U?format=jpg&name=large',
        'https://pbs.twimg.com/media/FHmFbQdUYAIC-8a?format=jpg&name=medium',
        'https://pbs.twimg.com/media/FFP3mG2VQAEftz_?format=jpg&name=medium',
        'https://pbs.twimg.com/media/EcXXBpzUcAAlVl5?format=jpg&name=medium',
        'https://pbs.twimg.com/media/EgxjXEeUcAMDl2g?format=jpg&name=large',
        'https://pbs.twimg.com/media/Ey6LTDkVcAE8S8o?format=jpg&name=large',
        'https://pbs.twimg.com/media/Elr4Bt1VoAAIQsz?format=jpg&name=large',
        'https://pbs.twimg.com/media/EkJsgdhU0AETeKs?format=jpg&name=large',
        'https://pbs.twimg.com/media/Eex_NXcU0AAs4w_?format=jpg&name=medium',
        'https://pbs.twimg.com/media/EdutPxDVoAAXj7x?format=jpg&name=large',
        'https://pbs.twimg.com/media/EcR7igNU4AAzuAf?format=jpg&name=medium',
        'https://pbs.twimg.com/media/Ea7UwviU4AASDJF?format=jpg&name=medium',
        'https://pbs.twimg.com/media/Ea09XSQWkAAsKza?format=jpg&name=medium',
        'https://pbs.twimg.com/media/EaweINeU4AA6Oc7?format=jpg&name=medium',
    ];

}
